export default __webpack_public_path__ + "static/cta-mockup-dark-f26e9825a87af1bd9ab1187c6104c0cc.png";